import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "shadow-sm sm:overflow-hidden sm:rounded-md" }
const _hoisted_2 = { class: "space-y-6 bg-white px-4 py-4 sm:p-6" }
const _hoisted_3 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_4 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_5 = { class: "text-gray-400" }
const _hoisted_6 = { class: "flex flex-col sm:flex-row items-center gap-2 justify-between" }
const _hoisted_7 = { class: "text-gray-500" }
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = { class: "mb-3 flex items-center justify-between" }
const _hoisted_10 = { class: "flex items-center gap-2" }
const _hoisted_11 = {
  type: "button",
  class: "category-drag-handle inline-flex items-center p-1 text-gray-400 hover:text-gray-600 cursor-move"
}
const _hoisted_12 = { class: "font-semibold text-gray-900" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "text-xs text-gray-500 inline-flex items-center gap-1" }
const _hoisted_15 = {
  key: 0,
  class: "bg-white shadow-sm rounded-lg p-6"
}
const _hoisted_16 = { class: "text-center mb-6" }
const _hoisted_17 = { class: "font-medium text-gray-800 mb-2" }
const _hoisted_18 = { class: "text-sm text-gray-500 mb-1" }
const _hoisted_19 = { class: "text-xs text-gray-400" }
const _hoisted_20 = { class: "max-w-xs mx-auto" }
const _hoisted_21 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = { value: null }
const _hoisted_24 = ["value"]
const _hoisted_25 = { class: "my-2 block text-sm font-semibold text-gray-900" }
const _hoisted_26 = {
  key: 1,
  class: "w-full py-8 flex justify-center"
}
const _hoisted_27 = { class: "max-w-xs w-full" }
const _hoisted_28 = {
  key: 0,
  class: "relative cursor-pointer"
}
const _hoisted_29 = { class: "group h-full block max-w-50 sm:max-w-full w-full overflow-hidden rounded-lg bg-gray-100" }
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  type: "button",
  class: "absolute inset-0 focus:outline-hidden cursor-pointer"
}
const _hoisted_32 = { class: "sr-only" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "absolute bottom-0 rounded-lg w-full p-1.5 left-0 text-white text-sm bg-gradient-to-t from-black/80 to-transparent" }
const _hoisted_35 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = { value: null }
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "my-2 block text-sm font-semibold text-gray-900" }
const _hoisted_40 = {
  key: 1,
  class: "w-full py-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_Bars3Icon = _resolveComponent("Bars3Icon")!
  const _component_PencilSquareIcon = _resolveComponent("PencilSquareIcon")!
  const _component_DocumentIcon = _resolveComponent("DocumentIcon")!
  const _component_ChevronDownIcon = _resolveComponent("ChevronDownIcon")!
  const _component_FileUploaderComponent = _resolveComponent("FileUploaderComponent")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_AddNewGroupToPortfolio = _resolveComponent("AddNewGroupToPortfolio")!
  const _component_EditGroupInPortfolio = _resolveComponent("EditGroupInPortfolio")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('profile.portfolio_title')), 1),
          _createElementVNode("p", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t('profile.portfolio_tip')) + " ", 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('profile.portfolio_tip_2')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t('profile.portfolio_groups.description')), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              type: "button",
              class: "inline-flex items-center gap-1 rounded-md border border-royal-blue-600 text-royal-blue-600 px-2 py-1.5 text-xs hover:bg-royal-blue-600 cursor-pointer hover:text-white",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.beginAddGroup && _ctx.beginAddGroup(...args)))
            }, [
              _createVNode(_component_PlusIcon, { class: "size-4" }),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('profile.portfolio_groups.add_button')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_draggable, {
      modelValue: _ctx.groupNamesArray,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.groupNamesArray) = $event)),
      onEnd: _ctx.onCategoryDragEnd,
      "item-key": "name",
      tag: "div",
      handle: ".category-drag-handle",
      group: { name: 'portfolio-categories', pull: false, put: false },
      class: "py-4 grid gap-6"
    }, {
      item: _withCtx(({ element: groupName }) => [
        (_openBlock(), _createElementBlock("section", {
          key: groupName,
          class: "rounded-md"
        }, [
          _createElementVNode("header", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", _hoisted_11, [
                _createVNode(_component_Bars3Icon, { class: "size-5" })
              ]),
              _createElementVNode("h4", _hoisted_12, _toDisplayString(groupName), 1),
              _createElementVNode("button", {
                type: "button",
                class: "inline-flex items-center gap-x-1 rounded-md border-royal-blue-600 text-royal-blue-600 p-1 text-xs hover:bg-royal-blue-600 cursor-pointer hover:text-white",
                onClick: ($event: any) => (_ctx.startRename(groupName))
              }, [
                _createVNode(_component_PencilSquareIcon, { class: "size-4" }),
                _cache[3] || (_cache[3] = _createElementVNode("span", null, "Edit", -1))
              ], 8, _hoisted_13)
            ]),
            _createElementVNode("span", _hoisted_14, [
              _createVNode(_component_DocumentIcon, { class: "size-3" }),
              _createTextVNode(" " + _toDisplayString(_ctx.groupedLocal[groupName]?.length || 0), 1)
            ])
          ]),
          (Array.isArray(_ctx.groupedLocal[groupName]) && _ctx.groupedLocal[groupName].length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('profile.portfolio_groups.empty_group.title')), 1),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('profile.portfolio_groups.empty_group.description')), 1),
                  _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('profile.portfolio_groups.empty_group.auto_delete')), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["relative block w-full rounded-lg border-2 border-dashed border-gray-300 text-center hover:border-gray-400 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden", {'p-3': _ctx.galleriesToSelect.length, 'flex items-center justify-center min-h-[180px] px-3': !_ctx.galleriesToSelect.length}])
                  }, [
                    (_ctx.galleriesToSelect.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_21, [
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": ($event: any) => ((_ctx.addItemForms[groupName].gallery) = $event),
                              class: "col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pr-8 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                            }, [
                              _createElementVNode("option", _hoisted_23, _toDisplayString(_ctx.$t('profile.choose_file')), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.galleriesToSelect, (gallery, index) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: gallery,
                                  key: `gallery-select-item-option-${index}-${gallery.id}`
                                }, _toDisplayString(gallery.name), 9, _hoisted_24))
                              }), 128))
                            ], 8, _hoisted_22), [
                              [_vModelSelect, _ctx.addItemForms[groupName].gallery]
                            ]),
                            _createVNode(_component_ChevronDownIcon, {
                              class: "pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4",
                              "aria-hidden": "true"
                            })
                          ]),
                          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('profile.or')), 1),
                          _createVNode(_component_FileUploaderComponent, { group: groupName }, null, 8, ["group"])
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_FileUploaderComponent, { group: groupName }, null, 8, ["group"])
                          ])
                        ]))
                  ], 2)
                ])
              ]))
            : (Array.isArray(_ctx.groupedLocal[groupName]))
              ? (_openBlock(), _createBlock(_component_draggable, {
                  key: 1,
                  list: _ctx.groupedLocal[groupName] || [],
                  "item-key": "id",
                  group: { name: 'profile-portfolio', pull: true, put: true },
                  onEnd: _ctx.onDragEnd,
                  tag: "ul",
                  class: "grid grid-cols-2 gap-x-4 gap-y-8 bg-white shadow-sm rounded-lg p-3 sm:grid-cols-3 sm:gap-x-6 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-4"
                }, {
                  item: _withCtx(({ element }) => [
                    (element.id !== 'add')
                      ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("img", {
                              src: element.cover_url,
                              alt: "",
                              class: "h-full group-hover:opacity-80 pointer-events-none aspect-10/7 object-cover"
                            }, null, 8, _hoisted_30),
                            _createElementVNode("button", _hoisted_31, [
                              _createElementVNode("span", _hoisted_32, _toDisplayString(element.title), 1)
                            ])
                          ]),
                          _createElementVNode("button", {
                            class: "absolute top-2 right-2 text-white bg-red-600 p-1 rounded-full hover:bg-red-700 focus:outline-none cursor-pointer",
                            onClick: ($event: any) => (_ctx.removeItem(element))
                          }, _cache[4] || (_cache[4] = [
                            _createElementVNode("svg", {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "16",
                              height: "16",
                              fill: "currentColor",
                              class: "bi bi-trash2",
                              viewBox: "0 0 16 16"
                            }, [
                              _createElementVNode("path", { d: "M14 3a.702.702 0 0 1-.037.225l-1.684 10.104A2 2 0 0 1 10.305 15H5.694a2 2 0 0 1-1.973-1.671L2.037 3.225A.703.703 0 0 1 2 3c0-1.105 2.686-2 6-2s6 .895 6 2zM3.215 4.207l1.493 8.957a1 1 0 0 0 .986.836h4.612a1 1 0 0 0 .986-.836l1.493-8.957C11.69 4.689 9.954 5 8 5c-1.954 0-3.69-.311-4.785-.793z" })
                            ], -1)
                          ]), 8, _hoisted_33),
                          _createElementVNode("p", _hoisted_34, _toDisplayString(element.title), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  footer: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["relative block w-full rounded-lg border-2 border-dashed border-gray-300 text-center hover:border-gray-400 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden", {'p-3': _ctx.galleriesToSelect.length, 'flex items-center justify-center min-h-[180px] px-3': !_ctx.galleriesToSelect.length}])
                    }, [
                      (_ctx.galleriesToSelect.length)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_35, [
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": ($event: any) => ((_ctx.addItemForms[groupName].gallery) = $event),
                                class: "col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-1.5 pr-8 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                              }, [
                                _createElementVNode("option", _hoisted_37, _toDisplayString(_ctx.$t('profile.choose_file')), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.galleriesToSelect, (gallery, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: gallery,
                                    key: `gallery-select-item-option-${index}-${gallery.id}`
                                  }, _toDisplayString(gallery.name), 9, _hoisted_38))
                                }), 128))
                              ], 8, _hoisted_36), [
                                [_vModelSelect, _ctx.addItemForms[groupName].gallery]
                              ]),
                              _createVNode(_component_ChevronDownIcon, {
                                class: "pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4",
                                "aria-hidden": "true"
                              })
                            ]),
                            _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('profile.or')), 1),
                            _createVNode(_component_FileUploaderComponent, { group: groupName }, null, 8, ["group"])
                          ], 64))
                        : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                            _createVNode(_component_FileUploaderComponent, { group: groupName }, null, 8, ["group"])
                          ]))
                    ], 2)
                  ]),
                  _: 2
                }, 1032, ["list", "onEnd"]))
              : _createCommentVNode("", true)
        ]))
      ]),
      _: 1
    }, 8, ["modelValue", "onEnd"]),
    _createVNode(_component_AddNewGroupToPortfolio, {
      open: _ctx.isAdding,
      onClose: _ctx.cancelAddGroup,
      onConfirmAction: _ctx.commitAddGroup
    }, null, 8, ["open", "onClose", "onConfirmAction"]),
    _createVNode(_component_EditGroupInPortfolio, {
      open: _ctx.editingValue !== '',
      value: _ctx.editingValue,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancelRename(_ctx.editingValue))),
      onConfirmAction: _ctx.applyRename
    }, null, 8, ["open", "value", "onConfirmAction"])
  ], 64))
}